import TemplateLibrary from '.';

export function toObject(arr) {

  /*
    Convert an array of objects to object dictionary.
    The input array looks like this: [{key: value}, {key: value}, ...]
    And we are converting it to be {
      key: value,
      key: value,
      ...
    }.
  */
  const obj = arr.reduce((acc, cur) => {
    acc = Object.assign(acc, cur);
    return acc;
  }, {});

  return obj;
}

export function getTemplateSettingsSchema(templateId) {
  const template = TemplateLibrary[templateId];
  const schema = template && template.schema && template.schema.templateSettings;

  // Some templates (Blank) have no settings: always hand back a list.
  return Array.isArray(schema) ? schema : [];
}
